// extracted by mini-css-extract-plugin
export default {"root":"ycV38pn8kBFXqW+AIMAQZg==","icon":"GkZWAIHK2Jl8vK5z7-9zEg==","compact":"v2Vvk9+h3uPsjh00A7r5Aw==","scrolled":"s72X7GEFbZ4JgN30ZMBO8A=="};